import { Link, useNavigate } from 'react-router-dom'
import { useCreateEvent } from '../../api/hooks'
import { Card, PageHeader } from '../../components/ui'
import { useToast } from '../../components/ui/toast'
import { EventForm } from './EventForm'

export function NewEventPage() {
  const create = useCreateEvent()
  const nav = useNavigate()
  const toast = useToast()
  return (
    <>
      <PageHeader title="Nytt event" crumbs={<Link to="/" className="hover:text-navy-800">Event</Link>} subtitle="Steg 1 av 3 – därefter genererar du kategorier och bygger inbjudan." />
      <Card className="max-w-3xl">
        <EventForm
          submitLabel="Skapa event"
          pending={create.isPending}
          error={create.error}
          onCancel={() => nav('/')}
          onSubmit={(data) => create.mutate(data, { onSuccess: (e) => { toast.push('success', 'Eventet skapades'); nav(`/event/${e.id}/kategorier`) } })}
        />
      </Card>
    </>
  )
}
